<template>
	<AssessmentCharacteristics class="strength-characteristics"
		:is-skeleton="isSkeleton"
		:high-type="highType"
		:characteristics="characteristics"
	>
		<template #icon>
			<FontAwesomeIcon
				:icon="[ `far`, `sparkles` ]"
			/>
		</template>
		<template #heading>{{ $t( "common.StrengthCharacteristics__heading" ) }}</template>
	</AssessmentCharacteristics>
</template>

<script>
import { TeamRoleType, OneOnOneTeamRoleType } from "@teaming/common-enums";
import CommonCharacteristics from "./CommonCharacteristicsProps";
import AssessmentCharacteristics from "./AssessmentCharacteristics";

const leaderRoles = [
	TeamRoleType.LEAD,
	OneOnOneTeamRoleType.MANAGER,
	OneOnOneTeamRoleType.PEER,
];

const memberRoles = [
	TeamRoleType.MEMBER,
	OneOnOneTeamRoleType.REPORT,
];

export default {
	name: "StrengthCharacteristics",
	mixins: [ CommonCharacteristics, ],
	components: {
		AssessmentCharacteristics,
	},
	props: {
		role: {
			type: String,
			required: true,
			validator( value ) {
				return TeamRoleType.includes( value ) ||
					OneOnOneTeamRoleType.includes( value );
			},
		},
	},
	computed: {
		characteristics() {
			const teamingContent = this.assessment?.teamingContent || {};
			if ( leaderRoles.includes( this.role ) ) {
				return teamingContent?.leader?.strengths || [];
			}
			if ( memberRoles.includes( this.role ) ) {
				return teamingContent?.member?.strengths || [];
			}
			return [];
		},
	},
};
</script>

<style lang="scss" scoped></style>
